<template>
<div id="container" v-if="notification && notification.type === 'INVOICE_CREATE'">
  <p><span></span>Был <u>создан</u> счет <strong>{{ invoice }}</strong><br> на сумму <strong>{{ amount }}</strong> {{ currency }}.<br></p><div align="right"><a href="#" @click="print">Распечатать чек</a></div>
</div>
</template>

<script>
  import utils from '../../../utils';
  import { mapGetters } from 'vuex';

  export default {
    name: 'NotificationInvoiceCreate',
    computed: {
      ...mapGetters(['currency', 'notification']),
      invoice() {
        return utils.formatInvoice(this.notification.invoice);
      },
      amount() {
        return utils.convertSystemToCurrency(this.notification.amount, this.currency);
      },
    },
    methods: {
      print() {
        const mywindow = window.open('', 'Print', 'height=600,width=800');
        mywindow.document.write('<html><head><title>Print</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write(`<h3 style="text-align:center;">${this.invoice}</h3>`);
        mywindow.document.write('</body></html>');
        mywindow.document.close();
        mywindow.focus();
        mywindow.print();
        mywindow.close();
        return true;
      }
    }
  };
</script>

<style scoped>
#container {
  margin-top: 10px;
  padding: 0.7em;
  border: 1px solid #add978;
  background: #d3f2c0;
  color: #333;
  border-radius: 6px;
  font-family: Verdana, sans-serif;
  font-size: 11px;
}
span {
  float: left;
  margin-right: 0.3em;
  width: 16px;
  height: 16px;
  display: block;
  text-indent: -99999px;
  overflow: hidden;
  background: url(../../../assets/ui-icons_2e83ff_256x240.png) no-repeat -208px -192px;
}
</style>
